'use client';

import { type Product } from '@/domain/products/types';
import { REPO_URL } from '@/services/api';
import pdf from '@/services/pdf';
import { LoadingButton } from '@/components/common/LoadingButton';
import PictureAsPdfOutlined from '@mui/icons-material/PictureAsPdfOutlined';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

interface BusinessModelTabProps {
  detailedProduct: Product;
}

const BusinessModelTab = ({ detailedProduct }: BusinessModelTabProps) => {
  const [isLoadingPDF, setIsLoadingPDF] = useState(false);

  const exportPDF = useCallback(async () => {
    try {
      setIsLoadingPDF(true);
      await pdf.downloadPDFAsync(`/pdf/from-repository/${detailedProduct.businessModels}`, detailedProduct.product);
      toast.success('Business Model downloaded successfully');
    } finally {
      setIsLoadingPDF(false);
    }
  }, [detailedProduct]);

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <iframe
        title={detailedProduct.product}
        id={detailedProduct.product}
        name={detailedProduct.product}
        sandbox="allow-same-origin"
        src={`${REPO_URL}/${detailedProduct.businessModels}`}
        style={{ width: '100%', height: '100%' }}
        allowFullScreen
      />
      <LoadingButton
        loading={isLoadingPDF}
        icon={<PictureAsPdfOutlined />}
        variant="outlined"
        onClick={exportPDF}
      >
        Export PDF
      </LoadingButton>
    </div>
  );
};

export default BusinessModelTab;
